import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'panel.'

@vsingleton()
export class PanelContentCampaignRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'content.campaigns.'

  index() {
    return this.ziggyRoute('index')
  }

  create() {
    return this.ziggyRoute('create')
  }

  getEligibleItems() {
    return this.ziggyRoute('get_eligible_items')
  }

  postStepOne() {
    return this.ziggyRoute('post_step_one')
  }

  redirectStepOne() {
    return this.ziggyRoute('redirect_step_one')
  }

  saveCampaignDraft() {
    return this.ziggyRoute('save_campaign_draft')
  }

  saveCampaign() {
    return this.ziggyRoute('save_campaign')
  }

  getStepOne(campaign: number) {
    return this.ziggyRoute('get_step_one', campaign)
  }

  destroyItem(campaignId: number, itemId: number) {
    return this.ziggyRoute('destroy_item', { campaign: campaignId, item: itemId })
  }

  getStepTwo(campaign: number) {
    return this.ziggyRoute('get_step_two', campaign)
  }

  validateCoupon(campaign: number) {
    return this.ziggyRoute('validate_coupon', campaign)
  }

  paymentLink(campaign: number) {
    return this.ziggyRoute('payment_link', campaign)
  }

  show(campaign: number) {
    return this.ziggyRoute('show', campaign)
  }

  destroy(campaign: number) {
    return this.ziggyRoute('destroy', campaign)
  }

  updateCampaignDetail(campaign: number) {
    return this.ziggyRoute('update_campaign_detail', campaign)
  }

  invoice(campaign: number) {
    return this.ziggyRoute('invoice', campaign)
  }
}